import { render, staticRenderFns } from "./InvoicePaymentForm.vue?vue&type=template&id=23dcce51&scoped=true&"
import script from "./InvoicePaymentForm.vue?vue&type=script&lang=ts&"
export * from "./InvoicePaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePaymentForm.vue?vue&type=style&index=0&id=23dcce51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcce51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
